import { render, staticRenderFns } from "./WfOnlineApiKeys.vue?vue&type=template&id=54d16d78"
import script from "./WfOnlineApiKeys.vue?vue&type=script&lang=ts"
export * from "./WfOnlineApiKeys.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54d16d78')) {
      api.createRecord('54d16d78', component.options)
    } else {
      api.reload('54d16d78', component.options)
    }
    module.hot.accept("./WfOnlineApiKeys.vue?vue&type=template&id=54d16d78", function () {
      api.rerender('54d16d78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/WfOnlineApiKeys.vue"
export default component.exports